import type { PropsWithChildren } from "react";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { AwsRumProvider } from "./aws-rum/AwsRumProvider";
import { ReactQueryProvider } from "./ReactQueryProvider";
import { useRecaptchaAccessibility } from "./recaptcha/use-recaptcha-accessibility";
import { SentryProvider } from "./sentry/SentryProvider";

export const Providers = ({ children }: PropsWithChildren) => {
  useRecaptchaAccessibility();

  return (
    <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_APP_SITE_KEY}>
      <ReactQueryProvider>
        <AwsRumProvider>
          <SentryProvider>{children}</SentryProvider>
        </AwsRumProvider>
      </ReactQueryProvider>
    </GoogleReCaptchaProvider>
  );
};
